const loginRoutes = {
  sso_login: "/sso_login",
};

export { loginRoutes };
